"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _MenuButton = _interopRequireDefault(require("../Menu/MenuButton"));
var _Separator = _interopRequireDefault(require("../Menu/Separator"));
var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _ToolbarOverflowLayout = _interopRequireDefault(require("./_ToolbarOverflowLayout"));
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _excluded = ["className", "cssBlock", "overflowButtonLabel", "overflowButtonProps", "onOverflowToggle", "overflowItemsSize", "children", "overlayProps", "popperId", "maxHeight", "showOverflowMenu"];
/* eslint-disable react/jsx-no-bind */
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ToolbarOverflow = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _overlayProps$id;
  var className = props.className,
    _props$cssBlock = props.cssBlock,
    cssBlock = _props$cssBlock === void 0 ? 'sapcnqr-toolbar' : _props$cssBlock,
    overflowButtonLabel = props.overflowButtonLabel,
    overflowButtonProps = props.overflowButtonProps,
    onOverflowToggle = props.onOverflowToggle,
    _props$overflowItemsS = props.overflowItemsSize,
    overflowItemsSize = _props$overflowItemsS === void 0 ? 'lg' : _props$overflowItemsS,
    children = props.children,
    overlayProps = props.overlayProps,
    popperId = props.popperId,
    maxHeight = props.maxHeight,
    showOverflowMenu = props.showOverflowMenu,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(showOverflowMenu),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOverlayOpen = _useState2[0],
    setIsOverlayOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    hasLeftIcon = _useState4[0],
    setHasLeftIcon = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    hasRightIcon = _useState6[0],
    setHasRightIcon = _useState6[1];
  (0, _react.useEffect)(function () {
    setIsOverlayOpen(showOverflowMenu);
  }, [showOverflowMenu]);
  var overflowTriggerRef = (0, _react.useRef)();
  var overflowRef = (0, _react.useRef)();
  var overflowDialogId = (0, _useUniqueId.default)();
  if (overlayProps !== null && overlayProps !== void 0 && (_overlayProps$id = overlayProps.id) !== null && _overlayProps$id !== void 0 && (0, _trim.default)(_overlayProps$id).call(_overlayProps$id)) {
    overflowDialogId = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.id;
  }
  var classnames = _bind.default.bind(_Toolbar.default);
  (0, _useFocusManager.default)({
    trapNode: overflowRef.current,
    nextKeyCode: _keycode.default.codes.down,
    previousKeyCode: _keycode.default.codes.up,
    firstFocusIndex: 0,
    onlyContainedEvents: true,
    trapWithTabbing: true,
    skipEvent: function skipEvent(event) {
      var _event$target, _event$target$getAttr, _event$target2, _event$target2$getAtt, _event$target3, _event$target4, _event$target4$getAtt;
      var activeDescendantId = (_event$target = event.target) === null || _event$target === void 0 || (_event$target$getAttr = _event$target.getAttribute) === null || _event$target$getAttr === void 0 ? void 0 : _event$target$getAttr.call(_event$target, 'aria-activedescendant');
      // if there is no active descendant, don't skip focus management
      if (!activeDescendantId) {
        return false;
      }

      // skip Toolbar focus management for SegmentedButton as it
      // manages its own active descendants.
      var firstOptionId = (_event$target2 = event.target) === null || _event$target2 === void 0 || (_event$target2 = _event$target2.firstElementChild) === null || _event$target2 === void 0 || (_event$target2$getAtt = _event$target2.getAttribute) === null || _event$target2$getAtt === void 0 ? void 0 : _event$target2$getAtt.call(_event$target2, 'id');
      var lastOptionId = (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.lastElementChild.getAttribute('id');

      // if segmented button has label get the 1st option like this:
      if (((_event$target4 = event.target) === null || _event$target4 === void 0 || (_event$target4 = _event$target4.firstElementChild) === null || _event$target4 === void 0 || (_event$target4$getAtt = _event$target4.getAttribute) === null || _event$target4$getAtt === void 0 ? void 0 : _event$target4$getAtt.call(_event$target4, 'role')) === 'presentation') {
        var _event$target5, _event$target5$getAtt;
        firstOptionId = (_event$target5 = event.target) === null || _event$target5 === void 0 || (_event$target5 = _event$target5.childNodes[1]) === null || _event$target5 === void 0 || (_event$target5$getAtt = _event$target5.getAttribute) === null || _event$target5$getAtt === void 0 ? void 0 : _event$target5$getAtt.call(_event$target5, 'id');
      }

      // if the active descendant is not the first or last option, skip focus management
      return activeDescendantId !== lastOptionId && (0, _keycode.default)(event) === 'down' || activeDescendantId !== firstOptionId && (0, _keycode.default)(event) === 'up';
    }
  }, isOverlayOpen && (overflowRef === null || overflowRef === void 0 ? void 0 : overflowRef.current), overflowRef);
  var classes = classnames("".concat(cssBlock, "__overflow"), className);
  var toggle = function toggle(value) {
    setIsOverlayOpen(value);
    if (typeof onOverflowToggle === 'function') {
      onOverflowToggle(value);
    }
  };
  var overflowTrigger = /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    "aria-controls": isOverlayOpen ? overflowDialogId : null,
    "aria-expanded": isOverlayOpen,
    "aria-haspopup": true,
    iconName: "kebab"
  }, overflowButtonProps, {
    onClick: (0, _chainFunction.default)(function () {
      return toggle(!isOverlayOpen);
    }, overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.onClick),
    className: classnames("".concat(cssBlock, "__overflow-trigger"), overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.className),
    active: isOverlayOpen,
    ariaLabel: overflowButtonLabel,
    ref: overflowTriggerRef
  }));
  var overflowPopperPlacement = ['right-start', 'left-start', 'right', 'left', 'auto'];
  var toolbarLayoutProps = {
    hasLeftIcon: hasLeftIcon,
    hasRightIcon: hasRightIcon,
    setHasLeftIcon: setHasLeftIcon,
    setHasRightIcon: setHasRightIcon
  };
  var addChildProps = (0, _react.useCallback)(function (classnamesFn, child, childProps) {
    if (child.displayName === 'ToolbarOverflowLayout') {
      return {
        size: overflowItemsSize
      };
    }
    if (child.displayName === 'Toolbar.Start' || child.displayName === 'Toolbar.Center' || child.displayName === 'Toolbar.End') {
      return {
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, _constants.CSS_PREFIX, "".concat(cssBlock, "__overflow-item"), "".concat(cssBlock, "__overflow-region"))
      };
    }
    if (child.displayName === 'Overlay') {
      var _childProps$targetPro;
      return childProps !== null && childProps !== void 0 && childProps['data-skip-toolbar-overflow-transformations'] ? {} : {
        popperPlacement: overflowPopperPlacement,
        targetProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.targetProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$targetPro = childProps.targetProps) === null || _childProps$targetPro === void 0 ? void 0 : _childProps$targetPro.className, "".concat(cssBlock, "__overflow-item"))
        }),
        targetComponent: (childProps === null || childProps === void 0 ? void 0 : childProps.targetComponent) && /*#__PURE__*/_react.default.cloneElement(childProps === null || childProps === void 0 ? void 0 : childProps.targetComponent, {
          toolbarOverflowEnd: /*#__PURE__*/_react.default.createElement(_Icon.default, {
            ariaHidden: true,
            iconName: "arrow-2-e",
            forceSize: "xs-plus"
          })
        })
      };
    }
    if (child.displayName === 'NavMenu') {
      var _childProps$overlayPr;
      return {
        inToolbarOverflow: true,
        size: overflowItemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(cssBlock, "__overflow-item")),
        overlayProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {}, {
          popperPlacement: overflowPopperPlacement,
          targetClassName: classnamesFn(childProps === null || childProps === void 0 || (_childProps$overlayPr = childProps.overlayProps) === null || _childProps$overlayPr === void 0 ? void 0 : _childProps$overlayPr.targetClassName, "".concat(cssBlock, "__overflow-item"))
        }),
        buttonProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.buttonProps), {}, {
          inToolbarOverflow: true,
          toolbarLayoutProps: toolbarLayoutProps
        }),
        iconProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.iconProps), {}, {
          iconName: 'arrow-2-e'
        })
      };
    }
    if (child.displayName === 'IconButton') {
      return {
        toolbarLayoutProps: toolbarLayoutProps,
        size: overflowItemsSize,
        inToolbarOverflow: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
        className: classnamesFn(_constants.CSS_PREFIX, "".concat(_constants.CSS_PREFIX, "-button-in-overflow"), childProps === null || childProps === void 0 ? void 0 : childProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-item"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false), "".concat(cssBlock, "__overflow-button"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false), "".concat(cssBlock, "__overflow-button--md"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false && overflowItemsSize === 'md'))
      };
    }
    if (child.displayName === 'IconLink') {
      return {
        toolbarLayoutProps: toolbarLayoutProps,
        inToolbarOverflow: true,
        size: overflowItemsSize
      };
    }
    if (child.displayName === 'FormField') {
      return {
        size: overflowItemsSize,
        layout: 'vertical'
      };
    }
    if (child.displayName === 'SegmentedButton') {
      var _childProps$labelProp, _childProps$listItemP, _childProps$listItemP2, _childProps$listItemP3;
      var listItemRenderer = function listItemRenderer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          text = _ref.text,
          icon = _ref.icon,
          key = _ref.key;
        return /*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.default, (0, _extends2.default)({
          size: overflowItemsSize,
          startIconOrBadge: icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
            ariaHidden: true,
            iconName: icon,
            size: overflowItemsSize === 'md' ? 'xs-plus' : 'sm'
          }),
          centerText: text,
          endIconOrBadge: (childProps === null || childProps === void 0 ? void 0 : childProps.selectedKey) === key && /*#__PURE__*/_react.default.createElement(_Icon.default, {
            ariaHidden: true,
            iconName: "check",
            className: classnames("".concat(cssBlock, "__overflow-check-icon")),
            size: overflowItemsSize === 'md' ? 'xs-plus' : 'sm'
          })
        }, toolbarLayoutProps));
      };
      return {
        size: overflowItemsSize,
        selectionFollowsFocus: false,
        orientation: 'vertical',
        listItemRenderer: listItemRenderer,
        label: (childProps === null || childProps === void 0 ? void 0 : childProps.label) || (childProps === null || childProps === void 0 ? void 0 : childProps.ariaLabel),
        labelProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.labelProps), {}, {
          className: classnames(childProps === null || childProps === void 0 || (_childProps$labelProp = childProps.labelProps) === null || _childProps$labelProp === void 0 ? void 0 : _childProps$labelProp.className, "".concat(cssBlock, "__overflow-segmented-button-label"), (0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-segmented-button-label--md"), overflowItemsSize === 'md'))
        }),
        listItemProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.listItemProps), {}, {
          className: classnames(childProps === null || childProps === void 0 || (_childProps$listItemP = childProps.listItemProps) === null || _childProps$listItemP === void 0 ? void 0 : _childProps$listItemP.className, "".concat(cssBlock, "__overflow-segmented-button-item"), (0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-segmented-button-item--md"), overflowItemsSize === 'md')),
          itemWrapperProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 || (_childProps$listItemP2 = childProps.listItemProps) === null || _childProps$listItemP2 === void 0 ? void 0 : _childProps$listItemP2.itemWrapperProps), {}, {
            className: classnames(_constants.CSS_PREFIX, childProps === null || childProps === void 0 || (_childProps$listItemP3 = childProps.listItemProps) === null || _childProps$listItemP3 === void 0 || (_childProps$listItemP3 = _childProps$listItemP3.itemWrapperProps) === null || _childProps$listItemP3 === void 0 ? void 0 : _childProps$listItemP3.className, "".concat(cssBlock, "__overflow-segmented-button-item-wrapper"), (0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-segmented-button-item-wrapper--md"), overflowItemsSize === 'md'))
          })
        }),
        className: classnames(_constants.CSS_PREFIX, childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(cssBlock, "__overflow-segmented-button"), (0, _defineProperty2.default)({}, "".concat(cssBlock, "--no-left"), !hasLeftIcon))
      };
    }
    if (child.displayName === 'Button') {
      return {
        toolbarLayoutProps: toolbarLayoutProps,
        inToolbarOverflow: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
        size: overflowItemsSize,
        type: childProps !== null && childProps !== void 0 && childProps['data-toolbar-group-part'] || (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'create' ? childProps === null || childProps === void 0 ? void 0 : childProps.type : 'link',
        className: classnamesFn(_constants.CSS_PREFIX, "".concat(_constants.CSS_PREFIX, "-button-in-overflow"), childProps === null || childProps === void 0 ? void 0 : childProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-button"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false), "".concat(cssBlock, "__overflow-button--md"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false && overflowItemsSize === 'md'), "".concat(cssBlock, "__overflow-item"), (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false))
      };
    }
    if (child.displayName === 'MenuButton') {
      var _childProps$overlayPr2;
      return {
        inToolbarOverflow: true,
        size: overflowItemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(cssBlock, "__overflow-item")),
        overlayProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {}, {
          popperPlacement: overflowPopperPlacement,
          targetClassName: classnamesFn(childProps === null || childProps === void 0 || (_childProps$overlayPr2 = childProps.overlayProps) === null || _childProps$overlayPr2 === void 0 ? void 0 : _childProps$overlayPr2.targetClassName, "".concat(cssBlock, "__overflow-item"))
        }),
        iconProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.iconProps), {}, {
          iconName: 'arrow-2-e'
        })
      };
    }
    if (child.displayName === 'SplitButton') {
      var _childProps$options, _childProps$options2, _childProps$options2$;
      return {
        inToolbarOverflow: true,
        replaceWithMenuButton: /*#__PURE__*/_react.default.createElement(_MenuButton.default, {
          inToolbarOverflow: true,
          buttonContents: childProps === null || childProps === void 0 || (_childProps$options = childProps.options) === null || _childProps$options === void 0 || (_childProps$options = _childProps$options[0]) === null || _childProps$options === void 0 ? void 0 : _childProps$options.text,
          onSelect: childProps === null || childProps === void 0 ? void 0 : childProps.onSelect
        }, childProps === null || childProps === void 0 || (_childProps$options2 = childProps.options) === null || _childProps$options2 === void 0 || (_childProps$options2$ = (0, _map.default)(_childProps$options2)) === null || _childProps$options2$ === void 0 ? void 0 : _childProps$options2$.call(_childProps$options2, function (option, idx) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
            key: option === null || option === void 0 ? void 0 : option.text
          }, /*#__PURE__*/_react.default.createElement(_MenuButton.default.Item, (0, _extends2.default)({
            label: option === null || option === void 0 ? void 0 : option.text
          }, option, {
            "data-key": idx
          })), idx === 0 && /*#__PURE__*/_react.default.createElement(_Separator.default, null));
        }))
      };
    }
    if (child.displayName === 'ToolbarSeparator') {
      return {
        horizontal: true
      };
    }
    if (child.displayName === 'Tooltip') {
      return {
        placement: ['right', 'left']
      };
    }
    if (child.displayName === 'Checkbox') {
      var _childProps$validatio, _childProps$validatio2, _childProps$validatio3, _childProps$validatio4, _childProps$validatio5, _childProps$validatio6, _childProps$inputProp;
      return {
        size: overflowItemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(_constants.CSS_PREFIX, "__overflow-checkbox"), "".concat(cssBlock, "__overflow-checkbox"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-checkbox--md"), overflowItemsSize === 'md'), "".concat(_constants.CSS_PREFIX, "__overflow-checkbox-with-validation"), (childProps === null || childProps === void 0 || (_childProps$validatio = childProps.validationMessage) === null || _childProps$validatio === void 0 ? void 0 : _childProps$validatio.state) && (childProps === null || childProps === void 0 || (_childProps$validatio2 = childProps.validationMessage) === null || _childProps$validatio2 === void 0 ? void 0 : _childProps$validatio2.text)), "".concat(cssBlock, "__overflow-checkbox-with-validation"), (childProps === null || childProps === void 0 || (_childProps$validatio3 = childProps.validationMessage) === null || _childProps$validatio3 === void 0 ? void 0 : _childProps$validatio3.state) && (childProps === null || childProps === void 0 || (_childProps$validatio4 = childProps.validationMessage) === null || _childProps$validatio4 === void 0 ? void 0 : _childProps$validatio4.text)), "".concat(cssBlock, "__overflow-checkbox-with-validation--md"), (childProps === null || childProps === void 0 || (_childProps$validatio5 = childProps.validationMessage) === null || _childProps$validatio5 === void 0 ? void 0 : _childProps$validatio5.state) && (childProps === null || childProps === void 0 || (_childProps$validatio6 = childProps.validationMessage) === null || _childProps$validatio6 === void 0 ? void 0 : _childProps$validatio6.text) && overflowItemsSize === 'md')),
        innerTextClassName: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.innerTextClassName, "".concat(cssBlock, "__overflow-checkbox-text")),
        inputProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.inputProps), {}, {
          className: classnames(childProps === null || childProps === void 0 || (_childProps$inputProp = childProps.inputProps) === null || _childProps$inputProp === void 0 ? void 0 : _childProps$inputProp.className, "".concat(cssBlock, "__overflow-checkbox-input"))
        })
      };
    }
    if (child.displayName === 'Link') {
      var _context;
      return {
        toolbarLayoutProps: toolbarLayoutProps,
        inToolbarOverflow: true,
        size: overflowItemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(cssBlock, "__overflow-item"), "".concat(cssBlock, "__overflow-link"), (0, _concat.default)(_context = "".concat(cssBlock, "__overflow-link--")).call(_context, overflowItemsSize))
      };
    }
    if (child.displayName === 'Select' || child.displayName === 'SelectPopoverField') {
      return {
        size: overflowItemsSize,
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DatePicker') {
      return {
        size: overflowItemsSize
      };
    }
    if (child.displayName === 'DateInputField') {
      return {
        size: overflowItemsSize
      };
    }
    if (child.displayName === 'DateSelect') {
      return {
        size: overflowItemsSize,
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DateRangeSelect') {
      return {
        size: overflowItemsSize,
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DateRangeInputField') {
      return {
        size: overflowItemsSize,
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'TimePicker') {
      return {
        size: overflowItemsSize,
        overlayProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {}, {
          popperPlacement: overflowPopperPlacement
        })
      };
    }
    if (child.displayName === 'InputField' || child.displayName === 'SelectField') {
      var _context2;
      return {
        size: overflowItemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(cssBlock, "__overflow-field"), "".concat(cssBlock, "__overflow-field-padding"), "".concat(cssBlock, "__overflow-item--margin"), (0, _concat.default)(_context2 = "".concat(cssBlock, "__overflow-item--margin-")).call(_context2, overflowItemsSize), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(cssBlock, "__overflow-field-padding--no-left"), !hasLeftIcon), "".concat(cssBlock, "__overflow-field-padding--md"), overflowItemsSize === 'md'))
      };
    }
    return {};
  }, [children, hasLeftIcon, hasRightIcon]);
  return /*#__PURE__*/_react.default.createElement(_Overlay.default, (0, _extends2.default)({
    maxWidth: 320
  }, overlayProps, {
    id: overflowDialogId,
    targetComponent: overflowTrigger,
    onShow: (0, _chainFunction.default)(function () {
      return toggle(true);
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onShow),
    onHide: (0, _chainFunction.default)(function () {
      return toggle(false);
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onHide, function () {
      var _overflowTriggerRef$c;
      return (_overflowTriggerRef$c = overflowTriggerRef.current) === null || _overflowTriggerRef$c === void 0 ? void 0 : _overflowTriggerRef$c.focus();
    }),
    popperPlacement: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperPlacement) || 'bottom-end',
    "data-nui-widgets": "toolbar-overflow",
    onClickOutside: function onClickOutside(e) {
      var _e$target;
      return (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest('[data-nui-widgets="toolbar-overflow"]')) !== null;
    },
    disableFocusManager: true,
    popperContentProps: {
      style: {
        maxHeight: maxHeight,
        overflow: 'auto'
      }
    },
    className: classnames("".concat(cssBlock, "__overlay")),
    show: isOverlayOpen
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, overflowRef])
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps.bind(null, classnames)
  }, children)));
});
ToolbarOverflow.displayName = 'ToolbarOverflow';
ToolbarOverflow.propTypes = {
  /** @ignore, set by Toolbar. */
  overflowButtonLabel: _propTypes.default.string.isRequired,
  /** @ignore, set by Toolbar. */
  className: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  cssBlock: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  overflowButtonProps: _propTypes.default.object,
  /** @ignore, set by Toolbar. */
  overflowItemsSize: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** @ignore, set by Toolbar. */
  children: _propTypes.default.node,
  /** @ignore, set by Toolbar. */
  popperId: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  overlayProps: _propTypes.default.object,
  /** @ignore, set by Toolbar. */
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** @ignore, set by Toolbar. */
  showOverflowMenu: _propTypes.default.bool,
  /** @ignore, set by Toolbar. */
  onOverflowToggle: _propTypes.default.func
};
var _default = exports.default = ToolbarOverflow;